import sliders from './script_sliders.js';
import cookies from './script_cookies.js';
import captcha from './script_captcha.js';
import publicMessage from './script_public_message.js';

import './script_pureclarity.js';

window.fbTrack = () => {
  if (window.fbTrackTimeout) clearTimeout(window.fbTrackTimeout);
  try {
    fbq('track', 'PageView');
  } catch (err) {
    window.fbTrackTimeout = setTimeout(window.fbTrack, 1000);
  }
};

window.cart_update_a = function () {
  $('table.radios tr').click(function (e) {
    $(this).find('input[type="radio"]').prop('checked', true);
    if ($(this).data('personal') === true) {
      $('tr[data-cash="cod"]').each(function () {
        $(this).addClass('disabled');
        $(this).find('input[type="radio"]').prop('checked', false);
        $(this).hide();
      });
      $('tr[data-cash="personal"]').each(function () {
        $(this).removeClass('disabled');
        $(this).find('input[type="radio"]').prop('checked', false);
        $(this).show();
      });
    } else {
      if ($(this).data('personal') === false) {
        $('tr[data-cash="personal"]').each(function () {
          $(this).addClass('disabled');
          $(this).find('input[type="radio"]').prop('checked', false);
          $(this).hide();
        });
        $('tr[data-cash="cod"]').each(function () {
          $(this).removeClass('disabled');
          $(this).find('input[type="radio"]').prop('checked', false);
          $(this).show();
        });
      }
    }

    Rails.fire($(this).closest('form')[0], 'submit');
  });

  document
    .querySelectorAll('#payments .payment, #transports .transport')
    .forEach((el) => {
      if (el.dataset.clickBinded) return;

      el.dataset.clickBinded = true;
      el.addEventListener('click', (e) => {
        el.querySelector('input[type="radio"]').checked = true;
        Rails.fire(el.closest('form'), 'submit');
      });
    });

  // BTNS
  $('.btn.no-js').hide();
  $('.btn.js').css({
    display: 'inline-block',
  });
};

window.refreshMethods = () => {
  if ($('.pictures a').length) {
    $('.pictures a').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true,
      },
    });
  }

  if ($('a.image-zoom').length) {
    $('a.image-zoom').magnificPopup({
      type: 'image',
      zoom: {
        enabled: true,
      },
      callbacks: {
        imageLoadComplete: () => {
          let image = document.querySelector('img.mfp-img');
          if (!image) return;
          if (
            image.width < window.innerWidth / 2 &&
            image.height < window.innerHeight / 2
          ) {
            image.style.width = `${2 * image.width}px`;
          }
        },
      },
    });
  }

  // Load Ares
  $('a.load-ares').unbind('click');
  $('a.load-ares').click(function (e) {
    e.preventDefault();
    e.target.classList.add('disabled');
    $('#cart_load_ares').val('1');
    $('.submit-form').trigger('click');
  });

  // Company / individual
  var checkEntityRadioButtons = ({ e = null, change = false } = {}) => {
    if (!document.querySelector('.cart-address-entity-type-selection')) return;
    let label;

    var el = document.querySelector(
      'input[name="cart[address_attributes][entity_type]"]:checked'
    );

    if (e) {
      el = e.target;
    }

    if (el && el.checked) {
      switch (el.value) {
        case 'company':
          if (document.querySelector('#cart_address_attributes_tax_no')) {
            document
              .querySelector('#cart_address_attributes_tax_no')
              .closest('.col-wrapper')
              .classList.remove('d-none');
            document
              .querySelector('#cart_address_attributes_name')
              .closest('.col-wrapper')
              .classList.remove('col-md-12');
          }

          if (
            document.querySelector('#profile_addresses_attributes_0_tax_no')
          ) {
            document
              .querySelector('#profile_addresses_attributes_0_tax_no')
              .closest('.col-wrapper')
              .classList.remove('d-none');
            document
              .querySelector('#profile_addresses_attributes_0_name')
              .closest('.col-wrapper')
              .classList.remove('col-md-12');
          }

          break;
        case ('individual', 'association'):
          // Mexico
          if (document.documentElement.lang == 'es-MX' && change) {
            alert(
              'Atención: Si decides no facturar ahora, no podrás hacerlo después. ¿Deseas continuar?'
            );
          }

          if (document.querySelector('#cart_address_attributes_tax_no')) {
            document
              .querySelector('#cart_address_attributes_tax_no')
              .closest('.col-wrapper')
              .classList.add('d-none');
            document.querySelector('#cart_address_attributes_tax_no').value =
              '';
            document
              .querySelector('#cart_address_attributes_name')
              .closest('.col-wrapper')
              .classList.add('col-md-12');
          }

          if (
            document.querySelector('#profile_addresses_attributes_0_tax_no')
          ) {
            document
              .querySelector('#profile_addresses_attributes_0_tax_no')
              .closest('.col-wrapper')
              .classList.add('d-none');
            document.querySelector(
              '#profile_addresses_attributes_0_tax_no'
            ).value = '';
            document
              .querySelector('#profile_addresses_attributes_0_name')
              .closest('.col-wrapper')
              .classList.add('col-md-12');
          }

          break;
      }

      label = JSON.parse(
        document.querySelector('input.address-name').dataset.labels
      )[el.value];
      document
        .querySelector('input.address-name')
        .closest('.col-wrapper')
        .querySelector('label').innerText = label;
    } else {
      label = JSON.parse(
        document.querySelector('input.address-name').dataset.labels
      ).company;
      document
        .querySelector('input.address-name')
        .closest('.col-wrapper')
        .querySelector('label').innerText = label;
    }
  };

  checkEntityRadioButtons();

  document
    .querySelectorAll(
      'input[name="cart[address_attributes][entity_type]"], input[name="profile[addresses_attributes][0][entity_type]"]'
    )
    .forEach((el) => {
      if (!el.dataset.changeEventBinded) {
        el.dataset.changeEventBinded = true;
        el.addEventListener('change', (e) => {
          checkEntityRadioButtons({ e, change: true });
        });
      }
    });

  sliders();

  document
    .querySelectorAll('input[type="checkbox"].vat-exemption')
    .forEach((el) => {
      if (!el.dataset.toggleBinded) {
        el.dataset.toggleBinded = true;

        el.addEventListener('change', (e) => {
          const vatEl = document.querySelector('.vat-exemption-document');
          if (!vatEl) return;

          if (e.target.checked) {
            vatEl.classList.remove('d-none');
          } else {
            vatEl.classList.add('d-none');
          }
        });
      }
    });

  document.querySelectorAll('.spinner-button').forEach((el) => {
    el.style.minWidth = `${el.offsetWidth}px`;
  });

  // end of refresh
};

var js = function () {
  // External links pop-up
  $('a[rel*=external]').click(function () {
    window.open($(this).attr('href'));
    return false;
  });

  // Search
  // NOTE: disable extending, we have space
  $('header .search').click(function () {
    if ($(this).hasClass('pasive')) {
      $(this).removeClass('pasive').addClass('active');
      $(this).animate({
        width: 245,
      });
      $(this).find('input').focus();
    }
  });

  $('header .search i').click(function () {
    var outsider = $(this).closest('.search');
    if (outsider.hasClass('active')) {
      outsider.animate(
        {
          width: 41,
        },
        function () {
          outsider.removeClass('active').addClass('pasive');
        }
      );
    }
  });

  $('form.search i').click(function () {
    Rails.fire($(this).closest('form')[0], 'submit');
  });

  // Move Up
  $('.move_up a').click(function (e) {
    e.preventDefault();
    $('body,html').animate({ scrollTop: 0 }, 'slow');
  });
  $('.move_up').css('display', 'block');
  $('.move_up').hide();

  var move_up = function () {
    var current_scroll = $(this).scrollTop();
    var window_height = $(window).height();
    var body_height = $('body').height();

    if (body_height > window_height && current_scroll > 40) {
      $('.move_up').fadeIn('slow');
    } else {
      $('.move_up').fadeOut('slow');
    }
  };

  move_up();
  $(window).scroll(move_up);

  var burger = function () {
    let link = document.querySelector('a.burger-menu-toggle');
    if (link && !link.dataset.menuToggleBinded) {
      link.dataset.menuToggleBinded = true;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        document.documentElement.classList.add('nav-opened');
      });
    }

    let close = document.querySelector('.inner .close');
    if (close && !close.dataset.closeBinded) {
      close.dataset.closeBinded = true;
      close.addEventListener('click', function (e) {
        e.preventDefault();
        document.documentElement.classList.remove('nav-opened');
      });
    }

    let navBg = document.querySelector('header nav.original');
    if (navBg && !navBg.dataset.menuToggleBinded) {
      navBg.dataset.menuToggleBinded = true;
      navBg.addEventListener('click', function (e) {
        if (e.target != document.querySelector('header nav.original')) return;
        e.preventDefault();
        document.documentElement.classList.remove('nav-opened');
      });
    }
  };

  burger();

  // $('.cat_slider').carouFredSel
  // # width: '100%'
  // direction: "left"
  // items:
  // width: 300
  // visible: 3
  // filter: 'div.wrapper'
  // scroll:
  // items: 1,
  // easing: "swing",
  // duration: 1000,
  // pauseOnHover: true

  // slider_init = ->
  //
  //
  // move_left = ->
  // width = $('.cat_slider a').outerWidth()
  // $('.cat_slider div.inside').animate(
  // left: '+=' + width
  // )
  //
  //
  // move_right = ->
  // width = $('.cat_slider a').outerWidth()
  // $('.cat_slider div.inside').animate(
  // left: '-=' + width
  // )
  //
  // if $('.cat_slider').length
  // slider_init()
  //
  // $('.controls a.left').click (e) ->
  // e.preventDefault()
  // move_left()
  //
  // $('.controls a.right').click (e) ->
  // e.preventDefault()
  // move_right()

  // Cart items
  $('tr.cart_item input.amount').bind('change', function () {
    Rails.fire($(this).closest('form')[0], 'submit');
  });
  $('tr.cart_item td.amount i').click(function (e) {
    e.preventDefault();
    var input = $(this).closest('td.amount').find('input.amount');
    if ($(this).hasClass('plus')) {
      input.val(parseInt(input.val()) + 1);
      Rails.fire($(this).closest('form')[0], 'submit');
    } else {
      if (parseInt(input.val()) <= 1) {
        $(this).closest('tr.cart_item').find('td.remove a').trigger('click');
      } else {
        input.val(parseInt(input.val()) - 1);
        Rails.fire($(this).closest('form')[0], 'submit');
      }
    }
  });

  window.cart_update_a();

  $('tr[data-hide="true"]').hide();

  // BTNS
  $('.btn.no-js').hide();
  $('.btn.js').css({
    display: 'inline-block',
  });

  // Delivery address
  var checkbox_address_same = $('.cart_address_same input[type="checkbox"]');
  if (checkbox_address_same.length) {
    if (checkbox_address_same.prop('checked')) {
      $('.delivery_address_wrapper').hide();
    }
    checkbox_address_same.change(function () {
      if ($(this).prop('checked')) {
        $('.delivery_address_wrapper').hide();
      } else {
        $('.delivery_address_wrapper').show();
      }
    });
  }

  // Language switcher
  document
    .querySelectorAll('.language-switcher button, .country-switcher button')
    .forEach((el) => {
      if (!el.dataset.dropdownBinded) {
        el.dataset.dropdownBinded = true;
        el.addEventListener('click', (e) => {
          const parent =
            e.target.closest('.language-switcher') ||
            e.target.closest('.country-switcher');
          const countries = parent.querySelector('ul.countries');
          if (countries.classList.contains('d-none')) {
            countries.classList.remove('d-none');
          } else {
            countries.classList.add('d-none');
          }
        });
      }
    });

  window.refreshMethods();
  cookies();
  window.fbTrack();
  window.pureClarity();
  window.pureClarityInit();
  captcha();

  // Filter
  document.querySelectorAll('.filter').forEach((filter) => {
    filter.querySelectorAll('select').forEach((select) => {
      if (!select.dataset.filterBinded) {
        select.dataset.filterBinded = true;
        select.addEventListener('change', (e) => {
          e.target.closest('form').requestSubmit();
        });
      }
    });
  });

  // end of js
};

var matomo = function () {
  if (typeof _paq === 'undefined') return;

  _paq.push(['setCustomUrl', window.location.pathname]);
  _paq.push(['setDocumentTitle', document.title]);
  _paq.push(['trackPageView']);
};

if (Turbo) {
  document.addEventListener('turbo:render', function () {
    js();
    matomo();
  });

  document.addEventListener('turbo:visit', function () {
    document.documentElement.classList.remove('nav-opened');
  });
} else {
  console.log('Turbo not available');
}

const primaryScript = document.querySelector('#primary_script');
primaryScript.addEventListener('load', (e) => {
  js();
});

const cookieBotScript = document.querySelector('#Cookiebot');
cookieBotScript.addEventListener('load', (e) => {
  cookies();
});

// We started to use JS-SDK
// const captchaScript = document.querySelector('#captcha_script')
// captchaScript.addEventListener('load', (e) => {
//   captcha();
// });

window.addEventListener('load', (e) => {
  publicMessage();
});

var cookieBotEvents = [
  'CookiebotOnLoad',
  'CookiebotOnAccept',
  'CookiebotOnDecline',
];
cookieBotEvents.forEach((eventName) => {
  window.addEventListener(eventName, cookies);
});

// Check if LocalStorage is available in the browser
function isLocalStorageAvailable() {
  try {
    const testKey = 'test';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

// Disable as we moved to Geo IP
// if (isLocalStorageAvailable()) {
//   if (!localStorage.getItem('secondaryVisit')) {
//     if (
//       navigator.language.toLowerCase() == 'de-at' &&
//       document.documentElement.lang != 'de-AT'
//     ) {
//       localStorage.setItem('secondaryVisit', 'true');
//       Turbo.visit(`/de-at${window.location.pathname}`);
//     }
//   }
// }

// Global click
const closeLanguageSwitcher = () => {
  document
    .querySelectorAll(
      '.language-switcher ul.countries, .country-switcher ul.countries'
    )
    .forEach((el) => {
      el.classList.add('d-none');
    });
};

document.addEventListener('click', (e) => {
  if (e.target.tagName != 'BUTTON') {
    closeLanguageSwitcher();
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeLanguageSwitcher();
  }
});
